// extracted by mini-css-extract-plugin
export var drawerPaper = "_3e-0";
export var itemImage = "_3e-1";